import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import Spinner from '../../UI/Spinner/Spinner';

const useStyles = makeStyles(() => ({
  visor: {
    width: '100%',
    height: '100%',
    border: 'none'
  },
  mensaje: {
    padding: '20px',
    textAlign: 'center'
  }
}));

/** Muestra el PDF de usePdfComprobante: el visor del navegador, el error o el spinner mientras se genera. */
const VisorPdf = ({ pdf, error }) => {
  const classes = useStyles();

  if (error) {
    return (
      <Typography className={classes.mensaje} color="error">
        {error}
      </Typography>
    );
  }
  return pdf ? <iframe title={pdf.nombreArchivo} src={pdf.url} className={classes.visor} /> : <Spinner />;
};

export default VisorPdf;
